import { defineMessages } from 'react-intl';

export default defineMessages({
  limitHeader: {
    id: 'benefitsTable.limitHeader',
    defaultMessage: 'Limit',
  },
  benefitHeader: {
    id: 'benefitsTable.benefitHeader',
    defaultMessage: 'Benefit',
  },
  excessHeader: {
    id: 'benefitsTable.excessHeader',
    defaultMessage: 'Excess',
  },
  deductibleHeader: {
    id: 'benefitsTable.deductibleHeader',
    defaultMessage: 'Deductible',
  },
  deductionsHeader: {
    id: 'benefitsTable.deductionsHeader',
    defaultMessage: 'Deductions',
  },
});
